import { Avatar, Button, Checkbox, Col, Flex, Form, Input, InputNumber, Radio, Row, Select, Space, Table, Tabs, Tag, Tooltip, Upload } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaCubes } from 'react-icons/fa';
import { Link, useParams, useLoaderData, useOutletContext, useNavigate } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { MdEdit } from 'react-icons/md';
import { RxUpdate } from "react-icons/rx";
import EventEmitter from '../../utils/eventEmitter';
import useProductAPI from '../apis/productAPI';
import { TbCameraPlus } from "react-icons/tb";
import { productPackagingColumns, productPurchaseTabColumns } from '../utils/tableColumns';
import EditableTable from '../../globalComponents/EditableTable';
import SmartButton from '../../globalComponents/SmartButton';
import { TfiMenuAlt } from "react-icons/tfi";
import { BsCreditCard2Back } from "react-icons/bs";
import { IoDocumentTextOutline } from "react-icons/io5";




const productTypes = [
  {value: 'storable', label: 'Storable Product', invoice_policy: [
    {value: 'ordered_quantities', label: 'Ordered Quantities'},
    {value: 'delivered_quantities', label: 'Delivered Quantities'}
  ]},
  {value: 'service', label: 'Service', invoice_policy: [
    {value: 'prepaid_fixed', label: 'Prepaid/Fixed'},
    {value: 'timesheet', label: 'Based on Timesheet'},
    {value: 'milestone', label: 'Based on Milestone'},
    {value: 'delivered_quantity', label: 'Based on Delivered Quantity'}
  ]}, 
  {value: 'consumable', label: 'Consumable Products'}, 
];


const ProductChanges = () => {
  const [form] = Form.useForm();
  const {categories, tags, product, locations, vendorList, taxes, routes} = useLoaderData();
  const { success, error, CustomBreadcrumb } = useOutletContext();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(product.name ? product.name : '');
  const { create, update } = useProductAPI();
  const [vendors, setVendors] = useState(product.name ? product.vendorproducts : []);
  const [invoicePolicy, setInvoicePolicy] = useState(productTypes[0].invoice_policy);

  const onChangeName = (e) => setName(e.target.value);
  // console.log(routes)
  const save = () => {
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    data['vendors'] = vendors;
    Object.entries(data).forEach(([key, value]) => {
      if (value === undefined) {
        data[key] = null;
      }
    });
    create(data, success);
    // console.log(data);
  }

  const edit = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    data['vendors'] = vendors;
    Object.entries(data).forEach(([key, value]) => {
      if (value === undefined) {
        data[key] = null;
      }
    });
    data['vendors'] = vendors;
    data['id'] = product.id;
    // console.log(data)
    update(product.seo, data, success);
  };

  useEffect(() => {
    EventEmitter.subscribe('product_response', data => {
      // navigate('/inventory/products/'+data);
    });

    // if (product) {
    //   product.tags.forEach(tag => {
    //     let tag_ = 
    //   });
    //   if (tagIndex !== -1) {
    //     console.log(tagIndex)
    //   }
    //   // form.setFieldValue('tagColor'+tag.id, tag.color);
    // }
    return () => EventEmitter.unsubscribe('product_response');
  },[])



  const onChangeProductType = (option) => {
    if (option.value === 'storable') {
      setInvoicePolicy(option.invoice_policy);
    }else if (option.value === 'consumable') {
      setInvoicePolicy(option.invoice_policy);
    }else if (option.value === 'service') {
      setInvoicePolicy(option.invoice_policy);
    }
  }


  const addVendorLine = () => {
    let vendors_ = [...vendors];
    const obj = {
      key: vendors.length,
      vendor_id: '',
      quantity: 0,
      price: 0
    };
    vendors_.push(obj);
    setVendors(vendors_);
  }

  return (
    <div className='container mx-auto' style={{ maxWidth: '1000px' }}>
      <div className='flex justify-between'>
        <div>
          <h3 className='font-bold flex'>
            <Link to={'/sales/products'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'><CustomBreadcrumb /> </Link>
            <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={save} type='text' htmlType='button'
              disabled={product.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={edit} type='text' htmlType='button'
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
          </h3>
          {product.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}
        </div>
        
      </div>
      <div className='mt-5 bg-white shadow'>
        <Flex className='border-b m-0'>
          <SmartButton icon={<BsCreditCard2Back size={'1.4rem'}/>} number={0} text={'Sold'}/>
          {/* <SmartButton icon={<IoDocumentTextOutline size={'1.4rem'}/>} number={0} text={'Digital Files'}/> */}
          
        </Flex>
        <Form
          form={form}
          className='p-3'
          labelAlign='left'
          labelCol={{ span: 8 }}
          labelWrap={true}
          initialValues={product.name ? product : {
            tracking: 'no_tracking',
            routes: ['buy'],
            control_policy: 'on_received_quantities',
            type: 'storable',
            invoicing_policy: 'ordered_quantities',
            operation_type: ['saleable', 'purchasable'],
            sales_price: 0,
            cost: 0,
            pos_availability: true,
            qty_availability: true
          }}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Row className='mt-5'>
            <Col md={{ span: 15 }}>
              <FloatingLabel
                className='text-2xl'
                variant="standard"
                // disabled={formValue.status!== 'discard' ? true : false}
                label="Product Name"
                value={name} 
                onChange={onChangeName}
              />
              <Row>
                <Col md={{span: 24}}>
                  <Form.Item name="operation_type" className='font-bold mb-2' required >
                    <Checkbox.Group>
                      <Space direction='horizontal'>
                        <Checkbox value={'saleable'}>Can be Sold</Checkbox>
                        <Checkbox value={'purchasable'}>Can be Purchase</Checkbox>
                        <Checkbox value={'expensable'}>Can be Expense</Checkbox>
                        <Checkbox value={'delivery_fee'}>Is Delivery Fee</Checkbox>
                      </Space>
                    </Checkbox.Group>
                  </Form.Item>
                </Col>
                {/* <Col md={{span: 6}}>
                  <Form.Item name="can_be_purchase" className='font-bold mb-2' valuePropName='checked' required >
                    <Checkbox>Can be Purchase</Checkbox>
                  </Form.Item>
                </Col>
                <Col md={{span: 6}}>
                  <Form.Item name="can_be_expense" className='font-bold mb-2' valuePropName='checked' required >
                    <Checkbox>Can be Expense</Checkbox>
                  </Form.Item>
                </Col> */}
              </Row>
              
            </Col>
            <Col md={{ span: 3, offset: 6 }}>
              <Upload
                name="picture"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                style={{height: '30px'}}
                
              >
                <Avatar icon={<TbCameraPlus />} />
              </Upload>
            </Col>
          </Row>
          <Tabs
            className='mt-3'
            type='card'
            items={[
              {
                key: 1,
                label: 'General Information',
                children:
                  <Row>
                    <Col lg={{ span: 11 }}>
                      <Form.Item label='Product Type' name="type" className='font-semibold text-gray-800 mb-2' required >
                        <Select options={productTypes} onChange={(v, option) => onChangeProductType(option)}/>
                      </Form.Item>
                      <Form.Item label='Invoicing Policy' name="invoicing_policy" className='font-semibold text-gray-800 mb-2' required >
                        <Select options={invoicePolicy}/>
                      </Form.Item>
                    </Col>  
                    <Col lg={{span: 11, offset: 1}}>
                      <Form.Item label='Sales Price' name='sales_price' className='font-semibold mb-1' >
                        <InputNumber className='font-normal w-full'/>
                      </Form.Item>
                      <Form.Item label='Customer Taxes' name="customer_tax_id" className='font-semibold text-gray-800 mb-1' >
                        <Select options={taxes.map(tax => ({value: tax.id, label: tax.name}))} style={{width: '100%'}}/>
                      </Form.Item>
                      <Form.Item label='Cost' name='cost_price' className='font-semibold mb-1' >
                        <InputNumber className='font-normal w-full'/>
                      </Form.Item>
                      <Form.Item label='Product Category' name='category_id' className='font-semibold mb-1'>
                        <Select options={categories.map(category => ({value: category.id, label: category.name}))} className='font-normal' style={{width: '100%'}}/>
                      </Form.Item>
                      <Form.Item label='Internal Reference' name='internal_reference' className='font-semibold mb-1'>
                        <Input type='text' placeholder='This can be the product SKU' className='font-normal input-outline-none'/>
                      </Form.Item>
                    </Col>
                    <Form.Item name='internal_notes' className='font-semibold mb-1 border-y-2 w-full mt-2'>
                      <Input type='text' placeholder='This note is only for internal purposes' className='font-normal input-outline-none ps-0'/>
                    </Form.Item>
                  </Row>
              },
              {
                key: 2,
                label: 'Attribute & Variants',
                children: <></>
              },
              {
                key: 3, 
                label: 'Sales',
                forceRender: true,
                children: 
                  <>
                    <Row className='mb-3'>
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 mb-3">UPSELL & CROSS-SELL</Badge>
                        <Form.Item label='Optional Products' name='optional_products' className='font-semibold mb-1'>
                          <Select mode='tags' className='font-normal'/>
                        </Form.Item>
                        <Form.Item label='Accessory Products' name='accessory_products' className='font-semibold mb-1'>
                          <Select mode='tags' className='font-normal'/>
                        </Form.Item>
                        <Form.Item label='Alternative Products' name='alternative_products' className='font-semibold mb-1'>
                          <Select mode='tags' className='font-normal'/>
                        </Form.Item>
                      </Col>
                      <Col md={{span: 11, offset: 1}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent border-b-2 mb-3">POINT OF SALE</Badge>
                        <Form.Item label='Available in PoS' name="pos_availability" className='font-semibold mb-2' valuePropName='checked' required >
                          <Checkbox />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 mb-3">ECOMMERCE SHOP</Badge>
                        <Form.Item label='Website' name='website' className='font-semibold mb-1'>
                          <Input type='url' className='font-normal input-outline-none'/>
                        </Form.Item>
                        <Form.Item label='Website Sequence' name='website_sequence' className='font-semibold mb-1'>
                          <Input type='text' className='font-normal input-outline-none'/>
                        </Form.Item>
                        <Form.Item label='Category' name='e_category' className='font-semibold mb-1'>
                          <Select className='font-normal'/>
                        </Form.Item>
                        <Form.Item label='Show Available Qty' name='qty_availability' className='font-semibold mb-1' valuePropName='checked'>
                          <Checkbox />
                        </Form.Item>
                        <Form.Item label='Out-of-Stock Message' name='out_of_stock_message' className='font-semibold mb-1' >
                          <Input type='text' className='font-normal input-outline-none' />
                        </Form.Item>
                      </Col>
                      <Col md={{span: 11, offset: 1}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 mb-3">EXTRA PRODUCT MEDIA</Badge>
                        <Button className='border-0'>ADD A MEDIA</Button>
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 mb-3">SALES DESCRIPTION</Badge>
                        <Form.Item name='sales_description' className='font-semibold mb-1' >
                          <Input type='text' placeholder='This note is added to sales order and invoices' className='font-normal input-outline-none' />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
              },
              {
                key: 4,
                label: 'Purchase',
                forceRender: true,
                children: 
                  <>
                    <EditableTable 
                      columns={productPurchaseTabColumns}
                      dataSource={vendors}
                      setDataSource={setVendors}
                      addLine={addVendorLine}
                      option1={[]}
                      contacts={vendorList}
                    />
                    <Row>
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">VENDOR BILLS</Badge>
                        <Form.Item label='Vendor Taxes' name="vendor_taxes" className='font-semibold text-gray-800 mb-1' >
                          <Select options={[]} style={{width: '100%'}}/>
                        </Form.Item>
                        <Form.Item label='Control Policy' name="control_policy" className='font-semibold text-gray-800 mb-1' >
                          <Radio.Group>
                            <Radio value={'on_ordered_quantities'}>On Ordered Quantities</Radio>
                            <Radio value={'on_received_quantities'}>On Received Quantities</Radio>
                          </Radio.Group>
                        </Form.Item>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">PURCHASE DESCRIPTION</Badge>
                        <Form.Item name='purchase_description' className='font-semibold mb-1' >
                          <Input type='text' placeholder='This note is added to purchase order' className='font-normal input-outline-none' />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
              },
              {
                key: 5,
                label: 'Inventory',
                forceRender: true,
                children: 
                  <>
                    <Row className='mb-3'>
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">OPERATIONS</Badge>
                        <Form.Item label='Routes' name="routes" className='font-semibold text-gray-800 mb-1' >
                          <Checkbox.Group>
                            <Space direction='vertical'>
                              {routes.map( route => 
                                <Checkbox key={route.id} value={route.id}>{route.name}</Checkbox>
                              )}
                            </Space>
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                      <Col md={{span: 11, offset: 1}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">LOGISTICS</Badge>
                        <Form.Item label='Responsible' name="responsible" className='font-semibold text-gray-800 mb-1' >
                          <Select options={[]} className='font-normal' />
                        </Form.Item>
                        <Form.Item label='Weight' name="weight" className='font-semibold text-gray-800 mb-1' >
                          <InputNumber className='font-normal w-full' />
                        </Form.Item>
                        <Form.Item label='Volume' name="volume" className='font-semibold text-gray-800 mb-1' >
                          <InputNumber className='font-normal w-full' />
                        </Form.Item>
                        <Form.Item label='Customer Lead Time' name="customer_lead_time" className='font-semibold text-gray-800 mb-1' >
                          <InputNumber className='font-normal w-full' />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">TRACEABILITY</Badge>
                        <Form.Item label='Tracking' name="tracking" className='font-semibold text-gray-800 mb-1' >
                          <Radio.Group>
                            <Space direction='vertical'>
                              <Radio value={'by_serial_number'}>By Unique Serial Number</Radio>
                              <Radio value={'by_lots'}>By Lots</Radio>
                              <Radio value={'no_tracking'}>No tracking</Radio>
                            </Space>
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                      <Col md={{span: 11, offset: 1}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">COUNTERPARTS LOCATIONS</Badge>
                        <Form.Item label='Inventory Location' name="inventory_location" className='font-semibold text-gray-800 mb-1' >
                          <Select options={locations.map(loc => ({value: loc.id, label: loc.name}))} className='font-normal' />
                        </Form.Item>
                      </Col>
                    </Row>
                    <div className='mb-3'>
                      <Table 
                        columns={productPackagingColumns}
                        dataSource={vendors}
                      />
                      <Button className='border-0'>Add Line</Button>
                    </div>
                    <Row className='mb-4'>
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">DESCRIPTION FOR RECEIPTS</Badge>
                        <Form.Item name='receipt_description' className='font-semibold mb-1' >
                          <Input type='text' placeholder='This note is added to receipt orders (eg. where to store the product in the warehouse)' className='font-normal input-outline-none' />
                        </Form.Item>
                      </Col>
                      <Col md={{span: 11, offset: 1}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">DESCRIPTION FOR DELIVERY ORDERS</Badge>
                        <Form.Item name='delivery_description' className='font-semibold mb-1' >
                          <Input type='text' placeholder='This note is added to delivery orders' className='font-normal input-outline-none' />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">DESCRIPTION FOR INTERNAL TRANSFER</Badge>
                        <Form.Item name='internal_transfer_description' className='font-semibold mb-1' >
                          <Input type='text' placeholder='This note is added to internal transfer orders (eg. where to pick the product in the warehouse)' className='font-normal input-outline-none' />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
              },
              {
                key: 6,
                label: 'Accounting',
                forceRender: true,
                children: 
                  <>
                    <Row className='mb-3'>
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">RECEIVABLES</Badge>
                        <Form.Item label='Income Account' name='income_account' className='font-semibold mb-1' >
                          <Select options={[]} className='font-normal' />
                        </Form.Item>
                      </Col>  
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">PAYABLES</Badge>
                        <Form.Item label='Expense Account' name='expense_account' className='font-semibold mb-1' >
                          <Select options={[]} className='font-normal' />
                        </Form.Item>
                      </Col>  
                    </Row>  
                  </>
              }
            ]}
          />
        </Form>
      </div>
    </div>
  )
}

export default ProductChanges;